export default "__VITE_ASSET__CTAmmxMm__"